import { Codebook } from '../Codebook'

export type DayHourId = number

export class DayHour extends Codebook<DayHourId> {
  static {
    for (let i = 0; i <= 23; ++i) {
      void new DayHour(i)
    }
  }

  name(): string {
    return `${this.id.toString().padStart(2, '0')}:00`
  }
}
